import { createSlice } from "@reduxjs/toolkit";

const draftsSlice = createSlice({
  name: "drafts",

  initialState: {
    items: [],

    loading: false,
    creating: false,
    updating: false,
    deleting: false,

    createSuccess: false,

    error: null,
  },

  reducers: {
    // =========================
    // CREATE DRAFT
    // =========================
    createDraftRequest: (state) => {
      state.creating = true;
      state.createSuccess = false;
      state.error = null;
    },

    createDraftSuccess: (state) => {
      state.creating = false;
      state.createSuccess = true;
    },

    createDraftFailure: (state, action) => {
      state.creating = false;
      state.error = action.payload;
    },

    resetDraftState: (state) => {
      state.createSuccess = false;
      state.error = null;
    },

    // =========================
    // FETCH DRAFTS
    // =========================
    fetchDraftsRequest: (state) => {
      state.loading = true;
      state.error = null;
    },

    fetchDraftsSuccess: (state, action) => {
      state.loading = false;
      state.items = action.payload;
    },

    fetchDraftsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // =========================
    // UPDATE DRAFT
    // =========================
    updateDraftRequest: (state) => {
      state.updating = true;
      state.error = null;
    },

    updateDraftSuccess: (state) => {
      state.updating = false;
    },

    updateDraftFailure: (state, action) => {
      state.updating = false;
      state.error = action.payload;
    },

    // =========================
    // DELETE DRAFT
    // =========================
    deleteDraftRequest: (state) => {
      state.deleting = true;
      state.error = null;
    },

    deleteDraftSuccess: (state) => {
      state.deleting = false;
    },

    deleteDraftFailure: (state, action) => {
      state.deleting = false;
      state.error = action.payload;
    },
    resetDraftState: (state) =>{
      state.items = [];
      state.loading = false;
      state.creating = false;
      state.updating = false;
      state.deleting = false;
      state.createSuccess = false;
      state.error = null;
    }
  },
});

export const {
  createDraftRequest,
  createDraftSuccess,
  createDraftFailure,

  fetchDraftsRequest,
  fetchDraftsSuccess,
  fetchDraftsFailure,

  updateDraftRequest,
  updateDraftSuccess,
  updateDraftFailure,

  deleteDraftRequest,
  deleteDraftSuccess,
  deleteDraftFailure,

  resetDraftState,
} = draftsSlice.actions;

export default draftsSlice.reducer;